module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD9SURBVHgB7dfRCcIwGATgSzYQdBLRHYpLuIlxEl1CuoPiJApuoLa/opYWmzT/36f7XgqF5O4eAxARERERkaXyfF0fjtc1RpKS52Muw8PtvHe78nzbwJhkvPNiRvQOaHjcg+WIV/l7SDnTO6CYT/fVpdvPD6MRrfJV5mpZZfdwiFSeLgHOf4s7H4r5ZAsFXeWLxSzEnI0eIEEGI3LKSwUk0hyRW17iMYDGCI3yEo2BckZolZdYZBgyQrO8RCJTygjt8hIHBTEjLMpLFJT8G2FVXmKgqGuEfI3KSwSUtUb8Ui5fUx9Q6xxhUL5mMqDWGGFU3tzYDyEiIiIiIkryBABb2wcxnhoqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/form_icon_down_arrow.png
// module id = HtM9
// module chunks = 0